import { createPortal } from "react-dom";
// import '../../styles/AccountingSheetTableControl.css'
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useMap } from "react-leaflet";
import { useCallback } from "react";
import PrintIcon from '@mui/icons-material/Print';
import { getPaperDimensions } from "../PrintControl";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Badge, Box, CircularProgress, LinearProgress, Typography } from "@mui/material";
import { Tooltip, Paper } from "@mui/material";
import { useDispatch } from "react-redux";
import { setDarkMode } from "../../../store/reducers/helpersReducer";
export const statuses = {
    actual: {
        color: 'var(--color-orange)',
        icon: 'warning',
        text: 'Актуальные',
        next: 'not_completed'
    },
    not_completed: {
        color: 'var(--color-red)',
        icon: 'cancel',
        text: 'Не устранено',
        next: 'half_completed'
    },
    half_completed: {
        color: 'var(--color-yellow)',
        icon: 'remove_circle',
        text: 'Устранено частично',
        next: 'rejected'
    },
    rejected: {
        color: 'var(--color-purple)',
        icon: 'block',
        text: 'Отклонено',
        next: 'ready'
    },
    ready: {
        color: 'var(--color-blue)',
        icon: 'task_alt',
        text: 'Готово к проверке',
        next: 'completed'
    },
    completed: {
        color: 'var(--color-green)',
        icon: 'check_circle',
        text: 'Устранено',
        next: 'all'
    },
    all: {
        color: 'var(--btn-gray)',
        icon: 'list',
        text: 'Отобразить всё',
        next: 'actual'
    },
    not_identified: {
        color: 'black',
        icon: '',
        text: '',
        next: 'all'
    }
}

export const translate = {
    'Устранено': 'completed',
    'Готово к проверке': 'ready',
    'Отклонено': 'rejected',
    'Устранено частично': 'half_completed',
    'Частично устранено': 'half_completed',
    'Не устранено': 'not_completed',
    'Актуальные': 'actual',
    'Отобразить всё': 'all'
}

const textLength = {
    1: [300, 330],
    2: [300, 330],
    3: [280, 440],
    4: [220, 480]
}

export function formarDate(date) {
    return `${new Date(date).toLocaleTimeString()} ${new Date(date).toLocaleDateString()}`
}


const AccountingSheetTableControl = (props) => {
    const map = useMap()
    const dispatch = useDispatch()
    const [display, setDisplay] = useState('actual')
    const [hidden, setHidden] = useState('all')
    const [dark, setDark] = useState(localStorage.getItem('darkMode') === 'true')
    const [textPillars, setTextPillars] = useState('')
    const [textObjects, setTextObjects] = useState('')
    const [localPrinting, setLocalPrinting] = useState(false)
    const [localPrintingProgress, setLocalPrintingProgress] = useState(0)
    const [accounting, setAccounting] = useState(null)

    const [sortBy, setSortBy] = useState('id');
    const [sortOrder, setSortOrder] = useState('asc');

    const [count, setCount] = useState({
        not_completed: 0,
        half_completed: 0,
        ready: 0,
        active: 0,
        all: 0
    })
    const containerRef = useRef(null)
    const tableRef = useRef([]);
    const { accountingNewObjectFiltered, filter } = useSelector(
        (state) => state.state
    );

    const { printing } = useSelector(
        (state) => state.helper
    );
    useEffect(() => {
        if (accountingNewObjectFiltered) {
            setAccounting(accountingNewObjectFiltered)
        } else {
            setAccounting(null)
        }
    }, [accountingNewObjectFiltered])

    const SortIndicator = ({ column }) => {
        if (sortBy !== column) return null;
        return sortOrder === 'asc' ? ' ▲' : ' ▼';
    };

    const handleSort = (column) => {
        if (sortBy === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortBy(column);
            setSortOrder('asc');
        }
    };

    useEffect(() => {
        setTimeout(() => {
            dispatch(setDarkMode(dark))
        }, 1000)
    }, [dark])

    useEffect(() => {
        setDark(localStorage.getItem('darkMode') === 'true')
    }, [hidden])

    const filterAccounting = useCallback(() => {
        if (accountingNewObjectFiltered) {
            setAccounting(accountingNewObjectFiltered.map(ano => {
                if (textObjects) {
                    const searchWords = textObjects.toLowerCase().split(/\s+/).filter(word => word.length > 0);
                    if (textObjects !== '' && !searchWords.every(word =>
                    `Объект: ${ano.ps ? ano.ps.name + ' ' + ano.ps.operating_voltage + ' ' : ''}${ano.tp.tp ? ano.tp.tp : ano.tp.name.split('(')[0].trim()} ${ano.town} — ${ano.type}`.toLowerCase().includes(word))
                ) {
                    return null
                }
            }

            let pillars = ano.pillars
            if (textPillars) {
                if (textPillars !== '') {
                    const searchWords = textPillars.toLowerCase().split(/\s+/).filter(word => word.length > 0);
                    pillars = ano.pillars.filter(pill =>
                        searchWords.every(word =>
                            `${pill.accounting.id} ${pill.name} ${pill.accounting.retreat_psd} ${pill.accounting.instructions} ${pill.accounting.status} ${pill.accounting.created} ${pill.accounting.creator}`.toLowerCase().includes(word))
                    )
                }
            }
            if (display) {
                switch (display) {
                    case 'completed':
                        pillars = pillars.filter(pillar => pillar.accounting.status === 'Устранено')
                        break;
                    case 'half_completed':
                        pillars = pillars.filter(pillar => pillar.accounting.status === 'Частично устранено')
                        break;
                    case 'not_completed':
                        pillars = pillars.filter(pillar => pillar.accounting.status === 'Не устранено')
                        break;
                    case 'rejected':
                        pillars = pillars.filter(pillar => pillar.accounting.status === 'Отклонено')
                        break;
                    case 'ready':
                        pillars = pillars.filter(pillar => pillar.accounting.status === 'Готово к проверке')
                        break;
                    case 'actual':
                        pillars = pillars.filter(pillar => pillar.accounting.status === 'Не устранено' || pillar.accounting.status === 'Частично устранено')
                        break;

                }
            }
            return {
                ...ano,
                pillars
                }
            }).filter(f => f))
        }
    }, [textPillars, textObjects, display, accountingNewObjectFiltered])

    //Если менялись фильтры и не влкючен режим печати, то фильтруем
    useEffect(() => {
        if (!printing) {
            filterAccounting()
        }
    }, [textPillars, textObjects, display, accountingNewObjectFiltered])

    //При изменении состояния подсчитываем общее количество
    useEffect(() => {
        if (accounting) {
            setCount((p) => ({
                ...p,
                all: accounting.reduce((t, r) => t + r.pillars.length, 0)
            }))
        }

    }, [accounting, hidden])

    useEffect(() => {
        if (printing) {
            // const displayAccounting = displayNames && displayNames.accounting ? true : false
            // const displayAccountingCompleted = displayNames && displayNames.accounting_completed ? true : false
            const dialFilter = filter.find(f => f.type === 'dial')?.filter
            let activeTypes = new Set()
            if (dialFilter) {
                dialFilter.labelsOpacity.map((l, i) => {
                    if (i > 0) {
                        dialFilter.labels[i].map(label => activeTypes.add(label))
                    }

                })
            }

            activeTypes = [...activeTypes]
            setDark(false)
            let pillarsIds = []
            map.eachLayer(layer => {
                if (layer.options.type) {
                    if (layer.options.type.includes('pillar04_accounting')) {
                        pillarsIds.push(layer.options.data)
                    }
                    if (layer.options.type === 'cluster') {
                        layer.getLayers().map(l => {
                            if (l.options.type && l.options.type.includes('pillar04_accounting')) {
                                pillarsIds.push(l.options.data)
                            }
                        })
                    }
                }
            })

            setAccounting(accountingNewObjectFiltered.map(ano => {
                let pillars = ano.pillars.filter(pillar => pillarsIds.includes(pillar.fid))
                pillars = pillars.map(pillar => {
                    let type = pillar.type
                    let opacity = 2
                    dialFilter.labels.map((l, i) => {
                        if (i !== 0 && l.includes(type) && dialFilter.labelsOpacity[i] < opacity) opacity = dialFilter.labelsOpacity[i]
                    })
                    if (opacity === 0) {
                        opacity = dialFilter.labelsOpacity[0]
                        type = 'pillar04'
                    }
                    if (!dialFilter.labels[dialFilter.selectedLabel].includes(type)) return null
                    if (type === 'pillar04') return null
                    return {
                        ...pillar,
                        type,
                        opacity
                    }
                }).filter(f => f)


                // if (!displayAccountingCompleted) {
                //     pillars = pillars.filter(pillar => pillar.accounting.status !== 'Устранено')
                // }
                // if (!displayAccounting) {
                //     pillars = pillars.filter(pillar => pillar.accounting.status === 'Устранено')
                // }
                if (pillars && pillars.length > 0) {
                    return {
                        ...ano,
                        pillars
                    }
                }
                return null
            }).filter(f => f))
        } else {
            filterAccounting()
        }

    }, [printing])



 


    //Считаем количественные показатели для доп инфы рядом к иконкой
    useEffect(() => {
        const tofilter = ['Не устранено', 'Частично устранено']
        const tpFilter = filter.find(f => f.type === 'tp')?.filter
        const dateFilter = filter.find(f => f.type === 'date')?.filter
        if (accountingNewObjectFiltered) {
            let accounting = tpFilter ? accountingNewObjectFiltered.filter(ano => !tpFilter.find(f => f === ano.tp.fid)) : accountingNewObjectFiltered
            accounting = dateFilter ? accounting.map(ano => {
                return {
                    ...ano,
                    pillars: ano.pillars.filter(h => new Date(h.date) >= new Date(dateFilter.start) && new Date(h.date) <= new Date(dateFilter.end))
                }
            }) : accounting
            setCount((p) => ({
                ...p,
                active: accounting.reduce((t, r) => t + r.pillars.filter(pillar => tofilter.includes(pillar.accounting.status)).length, 0),
                not_completed: accounting.reduce((t, r) => t + r.pillars.filter(pillar => pillar.accounting.status === 'Не устранено').length, 0),
                half_completed: accounting.reduce((t, r) => t + r.pillars.filter(pillar => pillar.accounting.status === 'Частично устранено').length, 0),
                // active: 0,
                // ready: accountingNewObject.reduce((t, r) => t + r.pillars.filter(pillar => pillar.accounting.status === 'Частично устранено').length, 0)
                ready: accounting.reduce((t, r) => t + r.pillars.filter(pillar => pillar.accounting.status === 'Готово к проверке').length, 0),

            }))
            // setAccounting(accounting)
        }
    }, [accountingNewObjectFiltered, filter])



    async function printAccounting() {
        const a4 = getPaperDimensions('A4', 'landscape')
        const MM_TO_INCH = 1 / 25.4;
        const dpi = 150
        var w = ((a4.width - 10) * MM_TO_INCH) * dpi;
        var h = ((a4.height - 20) * MM_TO_INCH) * dpi;
        const delay = ms => new Promise(
            resolve => setTimeout(resolve, ms)
        );
        let tableImages = []
        const oldWidth = document.getElementsByClassName('accounting-table-control-expanded')[0].style.width
        document.getElementsByClassName('accounting-table-control-expanded')[0].style.width = `${w}px`
        await delay(1000)
        const tables = document.getElementsByName('accounting-table')
        for (let i = 0; i < tables.length; i++) {
            const table = tables[i];
            const headerHeight = table.childNodes[0].offsetHeight
            const rows = [...table.childNodes[1].childNodes]
            let rowsGroupsHeight = []
            let height = 0
            rows.map((r, index) => {
                const rowH = r.getBoundingClientRect().height
                if ((height + rowH) <= (h - headerHeight)) {
                    height += rowH
                    if (index === rows.length - 1) {
                        rowsGroupsHeight.push(height)
                    }
                } else {
                    rowsGroupsHeight.push(height)
                    height = rowH
                }
            })
            const headerImgData = await html2canvas(table.childNodes[0], {
                useCORS: true, // Если нужны кросс-доменные ресурсы
                logging: true,
                ignoreElements: document.getElementsByClassName('leaflet-control-container'),

            })

            const bodyImgData = await html2canvas(table.childNodes[1], {
                useCORS: true, // Если нужны кросс-доменные ресурсы
                logging: true,
                ignoreElements: document.getElementsByClassName('leaflet-control-container'),

            })

            const parts = []
            for (let y = 0; y < rowsGroupsHeight.length; y++) {
                const temph = rowsGroupsHeight[y]
                const tempw = bodyImgData.width
                const tempCanvas = document.createElement('canvas');
                tempCanvas.width = tempw
                tempCanvas.height = temph
                const tempCtx = tempCanvas.getContext('2d');
                tempCtx.drawImage(bodyImgData, 0, rowsGroupsHeight.slice(0, y).reduce((t, r) => t + r, 0), tempw, temph, 0, 0, tempw, temph)
                parts.push({
                    width: (tempCanvas.width / dpi) / MM_TO_INCH,
                    height: (tempCanvas.height / dpi) / MM_TO_INCH,
                    url: tempCanvas.toDataURL("image/png", 1.0)
                })

            }
            tableImages.push({
                header: {
                    width: (headerImgData.width / dpi) / MM_TO_INCH,
                    height: (headerImgData.height / dpi) / MM_TO_INCH,
                    url: headerImgData.toDataURL("image/png", 1.0)
                },
                body: parts
            })


        }
        document.getElementsByClassName('accounting-table-control-expanded')[0].style.width = oldWidth

        const pdf = new jsPDF({ format: [a4.width, a4.height], orientation: 'landscape', compress: false });
        pdf.setFont("Roboto-Medium");
        pdf.setFontSize(11);
        pdf.setLanguage('ru')


        const xOffset = 5
        const yOffset = 5
        const textHeigth = 5
        const pagesCount = tableImages.reduce((t, r) => t + r.body.length, 0)
        let currentPage = 1
        // const legengWidth = 100
        pdf.setTextColor('#8A8889')
        pdf.setFontSize(10);
        const date = new Date()
        const sdate = `${("0" + date.getDate()).slice(-2)}.${("0" + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()}`
        //Итерация по таблицам
        for (let i = 0; i < tableImages.length; i++) {
            //Итерация по страницам таблицы
            for (let y = 0; y < tableImages[i].body.length; y++) {
                if (currentPage !== 1) {
                    pdf.addPage([a4.width, a4.height], 'landscape')
                }
                //Колонтитул

                pdf.text(`Приложение №${i + 1} - Предписания Авторского надзора ООО «КОМОКС» на ${sdate}`, a4.width - xOffset, yOffset, { align: "right", baseline: "top" });

                //Заглавие таблицы
                pdf.addImage(tableImages[i].header.url, 'image/png', xOffset, yOffset + textHeigth, a4.width - (xOffset * 2), tableImages[i].header.height, undefined, "MEDIUM");
                //Тело таблицы
                pdf.addImage(tableImages[i].body[y].url, 'image/png',
                    xOffset,
                    yOffset + tableImages[i].header.height + textHeigth,
                    a4.width - (xOffset * 2),
                    tableImages[i].body[y].height,
                    undefined,
                    "MEDIUM");
                // pdf.rect(xOffset, yOffset, w - (xOffset * 2), h - (yOffset * 2))
                pdf.text(`стр. ${currentPage} из ${pagesCount}`, a4.width - xOffset, a4.height - yOffset, { align: "right", baseline: "bottom" });
                currentPage = currentPage + 1
            }
        }
        pdf.save(`Предписания авторского надзора ООО "КОМОКС" от ${sdate}.pdf`)
        setLocalPrinting(false)
    }

    useEffect(() => {
        if (localPrinting) {
            printAccounting()
        }
    }, [localPrinting])


    function getDisplayButton() {

        // if (display && Object.keys(statuses).includes(display)) {?
        if (display) {
            return (
                <div style={{ display: 'flex', flexDirection: 'row' }}>

                    <div className="filter-btn" style={{ backgroundColor: statuses[display].color, margin: '0 10px', fontWeight: 'bold' }}>
                        <span>{count.all || 0}</span>
                    </div>

                    <button id="statusFilterBtn" className="filter-btn" style={{ backgroundColor: statuses[display].color, fontWeight: 'bold' }}
                        onClick={e => {
                            setDisplay(statuses[display].next)
                        }}
                    >
                        <span className="material-icons status-icon" style={{ marginRight: '3px' }}>{statuses[display].icon}</span>
                        {statuses[display].text}
                    </button>
                </div>
            )
        }
        // } else {
        //     return (
        //         <button id="statusFilterBtn" className="filter-btn" style={{ backgroundColor: statuses.all.color }}
        //             onClick={e => {
        //                 setDisplay(statuses.all.next)
        //             }}
        //         >
        //             <span className="material-icons status-icon">{statuses.all.icon}</span>
        //             {statuses.all.text}
        //         </button>
        //     )
        // }
    }

    return (
        <>
            {createPortal(
                //      <div className="accounting-table-control" id='accounting-table-control' style={{
                //          zIndex: 1202

                //     }} onClick={() => { setHidden(false) }}> 

                // <div style={{
                //             // position: 'absolute',
                //             height: '34px',
                //             width: '34px',
                //             display: 'flex',
                //             justifyContent: 'center',
                //             margin: '5px 10px',
                //             color: '#ff0000',
                //             backgroundColor: 'rgb(40, 40, 40)',
                //             borderBottom: 'none',
                //             fontSize: '18px',
                //             boxShadow: '0px 2px 6px grey',
                //             borderRadius: '5px',
                //             opacity: '0.9',
                //             cursor: 'pointer'
                //         }}
                //             title='Предписания авторского надзора ООО "КОМОКС"'
                //         > 
                <Box sx={{ zIndex: 1202, display: 'flex', order: 4 }}>
                    <Tooltip title='Предписания авторского надзора ООО "КОМОКС"' placement='right'>
                        <Paper
                            elevation={3}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 34,
                                height: 34,
                                m: '5px 10px',
                                opacity: 0.9,
                                bgcolor: 'rgb(40, 40, 40)',
                                color: 'orange',
                                cursor: 'pointer',
                                '&:hover': {
                                    bgcolor: 'rgb(50, 50, 50)',
                                },
                                zoom: window.innerWidth < 768 ? 0.8 : 1
                            }}
                            onClick={() => setHidden(false)}
                        >

                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{ alignSelf: 'center', margin: "0 5px" }}>
                                    <path d="M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
                                        fill='white'
                                    />
                                </svg>

                                {/* Badge для not_completed - верхний правый угол */}
                                {count && count.not_completed > 0 && (
                                    <Badge
                                        badgeContent={count.not_completed}
                                        color="error"
                                        max={999}
                                        variant="standard"
                                        sx={{
                                            position: 'absolute',
                                            top: -4,
                                            right: -4,
                                            '& .MuiBadge-badge': {
                                                color: 'white',
                                                backgroundColor: 'var(--color-red)',
                                                fontSize: '12px',
                                                padding: '3px',
                                                height: 'auto',
                                                width: 'auto',
                                            },
                                        }}
                                    />
                                )}

                                {/* Badge для half_completed - верхний левый угол */}
                                {count && count.half_completed > 0 && (
                                    <Badge
                                        badgeContent={count.half_completed}
                                        color="warning"
                                        max={999}
                                        variant="standard"
                                        sx={{
                                            position: 'absolute',
                                            top: 13,
                                            right: -4,
                                            '& .MuiBadge-badge': {
                                                color: 'black',
                                                backgroundColor: 'var(--color-orange)',
                                                fontSize: '12px',
                                                padding: '2px',
                                                width: 'auto',
                                                height: 'auto',
                                            }
                                        }}
                                    />
                                )}

                                {/* Badge для ready - нижний правый угол */}
                                {count && count.ready > 0 && (
                                    <Badge
                                        badgeContent={count.ready}
                                        color="secondary"
                                        max={999}
                                        variant="standard"
                                        sx={{
                                            position: 'absolute',
                                            bottom: -6,
                                            right: -4,
                                            '& .MuiBadge-badge': {
                                                color: 'white',
                                                backgroundColor: 'var(--color-blue)',
                                                fontSize: '12px',
                                                padding: '2px',
                                                width: 'auto',
                                                height: 'auto',
                                            }
                                        }}
                                    />
                                )}
                            </Box>

                            {/* </div> */}

                            {/* bottom: '40px', */}
                            {/* < div style={{ position: 'absolute', display: 'flex', flexDirection: 'row', left: '32px', marginTop: '-20px', cursor: 'pointer' } */}
                            {/* }> */}
                            {/* {count && count.active > 0 ?
                            <div style={{ position: 'relative' }}>
                                <div style={{ position: 'absolute' }}>
                                    <svg className="shadow1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
                                        <circle cx="256" cy="256" r="236" fill="var(--color-red)" strokeWidth="0" fillOpacity="1" />
                                    </svg>
                                </div>
                                <div style={{ position: 'relative', margin: '0px 0px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="30 -30 512 512">
                                        <text x="290" y="256" fontSize={textLength[count.active.toString().length][0]} fill="white" lengthAdjust="spacing" textAnchor="middle" textLength={textLength[count.active.toString().length][1]} alignmentBaseline="middle" fontStyle="bold" >
                                            {count.active}
                                        </text>
                                    </svg>
                                </div>
                            </div> : null
                        } */}

                            {/* {
                            count && count.ready > 0 ?
                                <div style={{ position: 'relative' }}>
                                    <div style={{ position: 'absolute' }}>
                                        <svg className="shadow1" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                                            <circle cx="256" cy="256" r="236" fill="var(--color-blue)" strokeWidth="0" fillOpacity="1" />
                                        </svg>
                                    </div>
                                    <div style={{ position: 'absolute', margin: '0px 0px' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="30 -30 512 512">
                                            <text x="290" y="256" fontSize={textLength[count.ready.toString().length][0]} fill="white" lengthAdjust="spacing" textAnchor="middle" textLength={textLength[count.ready.toString().length][1]} alignmentBaseline="middle" fontStyle="bold" >
                                                {count.ready}
                                            </text>
                                        </svg>
                                    </div>
                                </div> : null
                        } */}

                            {/* </div > */}

                            {/* {
                        count && count.active > 0 ?
                            <div style={{ position: 'relative', left: '25%', bottom: '25%', display: 'flex', justifyContent: 'end' }}>
                                <div style={{ position: 'absolute', display: 'flex', margin: '-2px 3px' }}>
                                    <svg className="shadow1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
                                        <circle cx="256" cy="256" r="236" fill="var(--color-red)" strokeWidth="0" fillOpacity="1" />
                                    </svg>
                                </div>
                                <div style={{ position: 'absolute', display: 'flex', margin: '-2px 4px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="24 -24 512 512">
                                        <text x="290" y="256" fontSize={textLength[count.active.toString().length][0]} fill="white" lengthAdjust="spacing" textAnchor="middle" textLength={textLength[count.active.toString().length][1]} alignmentBaseline="middle" fontStyle="bold" >
                                            {count.active}
                                        </text>
                                    </svg>
                                </div>
                            </div> : null
                    } */}

                            {/* </di    v > */}
                        </Paper>
                    </Tooltip>
                </Box>, document.getElementById("map-controls-left-top-left"))
            }

            {
                hidden ? null :
                    createPortal(<>
                        <div className="accounting-table-control-expanded" style={{
                            position: 'absolute',
                            display: 'flex',
                            flexDirection: 'column',
                            top: 0,
                            zIndex: 10000,
                            backgroundColor: dark ? "#121212" : "#ffffff",
                            color: dark ? "#e0e0e0" : "#000000",
                            transition: "all 0.3s ease",
                            width: "100%",
                            height: "100%",
                            padding: "10px",
                            overflowY: 'auto',
                            transition: 'all 0.3s ease'
                        }}
                            ref={containerRef}
                        >
                            <div style={{ display: printing ? 'none' : 'flex', flexDirection: window.innerWidth > 768 ? 'row' : 'column', justifyContent: window.innerWidth > 768 ? 'space-between' : 'space-around', margin: '5px 0' }}>
                                <div className="table-control-header" style={{ display: 'flex', flexDirection: 'row' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#000000" style={{ alignSelf: 'center' }}>
                                        <path d="M180-120q-25 0-42.5-17.5T120-180v-600q0-25 17.5-42.5T180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q25 0 42.5 17.5T840-780v600q0 25-17.5 42.5T780-120H180Zm100-160h273v-60H280v60Zm0-170h400v-60H280v60Zm0-170h400v-60H280v60Zm200-177q14 0 24.5-10.5T515-832q0-14-10.5-24.5T480-867q-14 0-24.5 10.5T445-832q0 14 10.5 24.5T480-797Z"
                                            fill={dark ? 'white' : 'black'}
                                        />
                                    </svg>
                                    <span style={{ fontWeight: 'bold' }}>Предписания авторского надзора ООО "КОМОКС"</span>
                                </div>
                                <div className="table-control-header-ext" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>

                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <input type="text" id="searchInput" placeholder="Поиск" style={{ width: "280px", border: "1px solid #ccc", borderRadius: "4px", padding: '2px 5px', margin: '0 10px', outline: 'none' }}
                                            onChange={e => setTextPillars(e.target.value)}
                                            value={textPillars}
                                        />
                                        {textPillars &&
                                            <button className='clear-input-button' onClick={e => setTextPillars('')}>
                                                <span className="material-icons" style={{ fontSize: '24px' }}>close</span>
                                            </button>
                                        }
                                    </div>
                                    {
                                        dark ?


                                            <button className="toggle-button" onClick={e => setDark(false)}>
                                                <span className="material-icons" id="themeIcon">light_mode</span>
                                            </button>

                                            :


                                            <button className="toggle-button" onClick={e => setDark(true)}>
                                                <span className="material-icons" id="themeIcon">dark_mode</span>
                                            </button>
                                    }





                                    <button className="toggle-button" onClick={e => setHidden(!hidden)}>
                                        <span className="material-icons" id="themeIcon">close</span>
                                    </button>

                                </div>
                            </div>
                            <div className="table-control-header-ext" style={{ display: printing ? 'none' : 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                    <input type="text" id="searchInput" placeholder="Поиск по объектам" style={{ width: "380px", border: "1px solid #ccc", borderRadius: "4px", padding: '2px 5px', margin: '0 10px', outline: 'none' }}
                                        onChange={e => setTextObjects(e.target.value)}
                                        value={textObjects}
                                    />
                                    {textObjects &&
                                        <button className='clear-input-button' onClick={e => setTextObjects('')}>
                                            <span className="material-icons" style={{ fontSize: '24px' }}>close</span>
                                        </button>
                                    }
                                </div>
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                    <button id="statusFilterBtn" className="filter-btn" style={{ backgroundColor: 'wheat', fontWeight: 'bold', color: 'black' }}
                                        onClick={e => {
                                            setLocalPrinting(true)
                                        }}
                                    >
                                        <PrintIcon style={{ marginRight: '5px' }} />
                                        Печать
                                    </button>
                                    {
                                        getDisplayButton()
                                    }
                                </div>




                            </div>





                            {
                                accounting ?
                                    accounting.map((acc, i) => {
                                        if (acc.pillars.length === 0) return null
                                        console.log(acc)
                                        return (
                                            <div key={acc.id} style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>

                                                <table key={i} ref={el => tableRef.current[i] = el} name='accounting-table' id="accounting-table" className={`${dark ? 'dark-mode' : ''} accounting-table`} style={{ marginTop: '10px' }}>
                                                    <thead className={dark ? 'dark-mode' : ''} >
                                                        <tr className={dark ? 'dark-mode' : ''}>
                                                            <th className={dark ? 'dark-mode' : ''} colSpan={6} style={{ borderTopLeftRadius: '6px', borderTopRightRadius: '6px', background: dark ? '#121212' : '#ffffff', padding: 0, color: dark ? 'white' : 'black' }}>
                                                                <div className="ext-table-header" style={{ display: 'flex', justifyContent: 'left', borderRadius: '6px', borderLeft: "8px solid #CD5C5C", padding: '10px', marginBottom: '5px' }}>
                                                                    <span style={{ marginRight: '10px' }}>{acc.pillars.length}</span>
                                                                    <span>{`Объект: ${acc.ps ? acc.ps.name + ' ' + acc.ps.operating_voltage + ' ' : ''}${acc.tp.tp ? acc.tp.tp : acc.tp.name.split('(')[0].trim()} ${acc.town}`}</span>

                                                                </div>
                                                            </th>

                                                        </tr>
                                                        <tr className={dark ? 'dark-mode' : ''}>
                                                            <th className="th-sorted" onClick={() => handleSort('id')} style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}>№ {<SortIndicator column="id" />}</th>
                                                            <th>Номер опоры</th>
                                                            <th>Выявленные отступления от ПСД</th>
                                                            <th>Указания и сроки их выполнения</th>
                                                            <th>Отметка о выполнении</th>
                                                            {/* <th>Создано</th> */}
                                                            <th>Авторский надзор</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table-body">
                                                        {
                                                            [...acc.pillars].sort((a, b) => {
                                                                return sortOrder === 'asc' ? a.accounting.id - b.accounting.id : b.accounting.id - a.accounting.id
                                                            }).map((pill, indx) => {
                                                                if (!pill.accounting.status) return null
                                                                let status = null
                                                                if (pill.accounting.status && Object.keys(translate).includes(pill.accounting.status)) {
                                                                    status = statuses[translate[pill.accounting.status]]
                                                                }
                                                                if (!status) return null
                                                                let color = status.color
                                                                let icon = status.icon

                                                                // let [editorfio, editorjob] = pill.accounting.editor.split('(').map(m => m.replaceAll(/[()]/g, '').trim())
                                                                // let [creatorfio, creatorjob] = pill.accounting.editor.split('(').map(m => m.replaceAll(/[()]/g, '').trim())
                                                                return (
                                                                    <tr key={indx}>
                                                                        <td style={{ textAlign: 'center' }}>{pill.accounting.id}</td>
                                                                        <td style={{ textAlign: 'center' }}>{pill.name}</td>
                                                                        <td>{pill.accounting.retreat_psd}</td>
                                                                        <td>
                                                                            <span style={{ color: color }}>{pill.accounting.instructions}</span>
                                                                        </td>
                                                                        <td style={{ color: color, textAlign: 'center' }}>
                                                                            <div>
                                                                                <span className="material-icons" style={{ margin: '0px 5px' }}>{icon}</span>
                                                                                <span style={{ verticalAlign: 'middle' }}>{status.text}</span>
                                                                            </div>
                                                                            <div>
                                                                                <span className="material-icons" style={{ margin: '0px 5px' }}>event</span>
                                                                                <span style={{ verticalAlign: 'middle' }}>{formarDate(pill.accounting.edited)}</span>
                                                                            </div>
                                                                            <div>
                                                                                <span className="material-icons" style={{ margin: '0px 5px' }}>engineering</span>
                                                                                <span style={{ verticalAlign: 'middle' }}>{pill.accounting.editor}</span>
                                                                            </div>


                                                                        </td>
                                                                        {/* <td style={{ color: 'var(--color-created)', textAlign: 'center' }}>

                                                                        </td> */}
                                                                        <td style={{ color: 'var(--color-created)', textAlign: 'center' }}>
                                                                            <div>
                                                                                <span className="material-icons" style={{ margin: '2px 5px' }}>event</span>
                                                                                <span style={{ verticalAlign: 'middle' }}>{pill.accounting.created}</span>
                                                                            </div>
                                                                            <div>
                                                                                <span className="material-icons" style={{ margin: '2px 5px' }}>engineering</span>
                                                                                <span style={{ verticalAlign: 'middle' }}>{pill.accounting.creator}</span>
                                                                            </div>

                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        )

                                    })
                                    : null
                            }
                            <button className="scroll-button" onClick={() => {
                                containerRef.current.scrollTo(0, 0)
                            }} style={{ background: '#a94442', display: printing ? 'none' : 'flex' }}>
                                <span className="material-icons" id="themeIcon" style={{ fill: 'white', color: 'white' }}>arrow_upward</span>

                            </button>

                            <button id="accounting-table-close" style={{ display: 'none' }} onClick={e => setHidden(true)}>

                            </button>




                        </div >
                        {
                            localPrinting ?
                                <div style={{ position: 'absolute', left: 0, top: 0, width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center', zIndex: 12000, backgroundColor: 'rgba(0, 0, 0, 0.5)', pointerEvents: 'auto' }}>
                                    <LinearProgress color="secondary" sx={{ height: '10px', width: '50%', borderRadius: '10px' }} />

                                </div>
                                : null
                        }
                    </>
                        , document.body)
            }
        </>
    )



}

export default AccountingSheetTableControl;
